module.exports = __webpack_public_path__ + "img/background.70c60ff1.jpg";